var _rect, _g, _polygon, _polygon2, _rect2, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShadeGuideMouldingHeight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "422px",
    height: "510px",
    viewBox: "0 0 422 510",
    enableBackground: "new 0 0 422 510",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 32.3,
    fill: "#DCDCDC",
    width: 349,
    height: 378.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 70.9,
    y: 104.5,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 2.9998,
    strokeMiterlimit: 10,
    width: 280.1,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 127.6,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 2.9998,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B2B2B2",
    stroke: "#717070",
    strokeWidth: 0.5283,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 36.5,41.5 36.5,31.9 0,31.9 8.5,41.5 36.4,41.5 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B2B2B2",
    stroke: "#717070",
    strokeWidth: 0.5283,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 385.6,41.7 413.5,41.7 422,32.1 385.5,32.1 385.5,41.7 "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    fill: "#C6C6C6",
    stroke: "#717070",
    strokeWidth: 0.5732,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 422,
    height: 32.1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.6327,
    x1: 211,
    y1: 486.5,
    x2: 211,
    y2: 7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "215.9,485 211,493.5 206.1,485  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "215.9,8.5 211,0 206.1,8.5  "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.6327,
    x1: 126.5,
    y1: 486.5,
    x2: 126.5,
    y2: 7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "131.4,485 126.5,493.5 121.6,485  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "131.4,8.5 126.5,0 121.6,8.5  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.6327,
    x1: 295.5,
    y1: 486.5,
    x2: 295.5,
    y2: 7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "300.4,485 295.5,493.5 290.6,485  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "300.4,8.5 295.5,0 290.6,8.5  "
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadeGuideMouldingHeight);
export default __webpack_public_path__ + "static/media/ShadeGuide-Moulding-Height-٠١.b835516b03018d2cd05a13631c182cd7.svg";
export { ForwardRef as ReactComponent };